export function hasPermission(rules, resource, action = "view") {
    if (!rules || typeof rules !== "object") return false;
    if (Array.isArray(rules.All) && rules.All.includes("*")) return true;
    if (!rules[resource]) return false;
    return rules[resource].includes(action);
}
